import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const goToSection = (id: string) => {
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 120);
    }
  };

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-primary-700">
                <i className="ri-table-line text-base"></i>
              </span>
              <span className="font-heading text-lg font-bold">{t("site.name")}</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-50/80">{t("footer.desc")}</p>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              {t("nav.visitMain")}
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-background-50/60">
              {t("footer.resources")}
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/usfans-spreadsheet-guide" className="text-background-50/85 transition-colors hover:text-background-50">
                  {t("footer.resources.guide")}
                </Link>
              </li>
              <li>
                <button type="button" onClick={() => goToSection("categories")} className="text-background-50/85 transition-colors hover:text-background-50">
                  {t("footer.resources.categories")}
                </button>
              </li>
              <li>
                <button type="button" onClick={() => goToSection("faq")} className="text-background-50/85 transition-colors hover:text-background-50">
                  {t("footer.resources.faq")}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-background-50/60">
              {t("footer.main")}
            </h4>
            <p className="mt-4 text-sm leading-relaxed text-background-50/85">{t("footer.main.desc")}</p>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="mt-4 inline-block whitespace-nowrap text-sm font-semibold text-accent-300 transition-colors hover:text-accent-200"
            >
              {t("site.name")} · {t("nav.buy")}
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-background-50/15 pt-6">
          <p className="text-xs leading-relaxed text-background-50/60">{t("footer.disclaimer")}</p>
          <p className="mt-3 text-xs text-background-50/50">{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
}